import { Shield, Heart } from "lucide-react";
import useReveal from "../hooks/useReveal";

const policies = [
  "Rides are by appointment only",
  "Please be ready within 5 minutes of arrival",
  "Late arrivals will incur wait fees",
  "Same-day bookings subject to availability",
  "Respectful behavior is required at all times",
];

export const Policy = () => {
  const r = useReveal();
  return (
    <section
      data-testid="policy-section"
      className="relative py-24 sm:py-32 px-5 sm:px-8"
    >
      <div ref={r} className="reveal max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <Shield
              className="w-6 h-6 text-[#D4AF37] mb-4"
              strokeWidth={1.4}
            />
            <span className="font-sans text-xs uppercase tracking-[0.32em] text-[#D4AF37]">
              Booking Policy
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-[1.1] tracking-tight">
              Boundaries that{" "}
              <span className="italic gold-text">
                protect us both.
              </span>
            </h2>
            <div className="flex items-center gap-3 mt-8 text-sm text-[#EAE6DF]">
              <Heart
                className="w-4 h-4 text-[#D4AF37]"
                strokeWidth={1.5}
              />
              <span className="font-light italic">
                Your safety and peace are the priority.
              </span>
            </div>
          </div>
          <div className="md:col-span-7">
            <ul className="border-t border-white/10">
              {policies.map((p, i) => (
                <li
                  key={p}
                  data-testid={`policy-item-${i}`}
                  className="border-b border-white/10 py-5 flex gap-5 group"
                >
                  <span className="font-serif text-base text-[#D4AF37]/70 italic w-10 shrink-0">
                    0{i + 1}
                  </span>
                  <p className="font-sans text-base sm:text-lg text-[#EAE6DF] font-light leading-relaxed group-hover:text-white transition-colors duration-300">
                    {p}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
